<template>
  <v-btn
    v-bind:disabled="downloading"
    v-bind:loading="downloading"
    right
    color="primary"
    x-large
    elevation="5"
    @click="$emit('click', $event)"
  >
    <v-icon large>mdi-download</v-icon>
    {{ label }}
  </v-btn>
</template>

<script>
  export default {
    name: 'DlBtn',
    components: {
    },
    props: {
      label: {
        type: String,
        required: false,
        default: '辞書DL',
      },
      downloading: {
        type: Boolean,
        required: false,
        default: false,
      },
    },
    methods: {
      onClick: function () {
        this.$emit('click')
      },
    },
  }
</script>
